import { URL_USER_DELETE_MODAL } from '../../../../_00_elements/tools/routes/routes';
import Attach from '../../../../_00_elements/tools/attach';
import { showSubmitLoader } from '../../../../_01_atoms/spinner';
import translation from '../../../../_00_elements/translation';
import Modal from '../../../../_01_atoms/components/Modal.vue';
import requests from '../../../../_00_elements/tools/requests-mixin';
import eventBus from '../../../../_00_elements/tools/event-bus';

export default {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: {
    isOpened: {
      type: Boolean,
      required: true,
    },
  },
  mixins: [ translation, requests ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
    };
  },
  methods: {
    close() {
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal) {
        return;
      }
      this.modalTitle = this.trans('user.modal.delete.title');
      this.get(URL_USER_DELETE_MODAL).then((templateResponse) => {
        this.htmlBody = templateResponse.data;

        Attach.onClickEvent('classic-cancel-button', () => {
          this.close();
        });

        this.$nextTick(() => {
          const deleteButton = document.getElementById('delete-button');
          if (deleteButton) {
            deleteButton.addEventListener('click', (event) => {
              event.preventDefault();
              showSubmitLoader(event.currentTarget);

              this.get(event.currentTarget.href).then(() => {
                eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
                  detail: {
                    oldModalName: 'Delete',
                    newModalName: 'DeleteSuccess',
                  },
                }));
              });
            });
          }
        });
      });
    },
  },
};
